import React from 'react'
import Flex from '../../commons/Flex/Flex'
import TimelineCommonFilters from './TimelineCommonFilters'

const TimelineFilters = () => {
  return (
    <Flex justifyContent="flex-start" width="100%" alignItems="center">
      <TimelineCommonFilters />
    </Flex>
  )
}

export default TimelineFilters
